import {Injectable} from '@angular/core';
import {Locale} from '../../utils/locale';
import {ParentAPIService} from '../parent.api.service';
import {HttpClient} from '@angular/common/http';
import {CrystalclearBackUrl} from './crystalclear-back-url';

@Injectable({
  providedIn: 'root'
})
export class ConfigService extends ParentAPIService {
  // The values that are defined here are the default values that can
  // be overridden by environment.ts

  // noinspection JSUnusedGlobalSymbols
  public baseHref = '/';

  public enableDebug = true;

  public lang = Locale.LANGS.EN_GB.id;

  public refreshPeriod: 5000 | undefined;

  public customerName: String = '';

  public relativeDesktopApplicationLink = './static/gui/cr_gui_installer.exe';

  constructor(http: HttpClient) {
    super(http);

  }
}
